import { __decorate } from "tslib";
import React, { cloneElement, Component } from 'react';
import { observer } from 'mobx-react';
import noop from 'lodash/noop';
import { pxToRem } from 'choerodon-ui/lib/_util/UnitConvertor';
import { getProPrefixCls as getProPrefixClsDefault } from 'choerodon-ui/lib/configure/utils';
import Button from '../../button/Button';
import { ButtonColor, FuncType } from '../../button/enum';
import Modal from '../../modal';
import Form from '../../form/Form';
import Icon from '../../icon';
import { $l } from '../../locale-context';
import autobind from '../../_util/autobind';
import TableButtons from './TableButtons';
import TableContext from '../TableContext';
let TableToolBar = class TableToolBar extends Component {
    static get contextType() {
        return TableContext;
    }
    get prefixCls() {
        const { prefixCls } = this.props;
        const { tableStore: { getProPrefixCls = getProPrefixClsDefault } } = this.context;
        return getProPrefixCls('table', prefixCls);
    }
    handleFieldEnter() {
        this.handleQuery();
        if (this.modal) {
            this.modal.close();
        }
    }
    handleQueryReset() {
        const { queryDataSet, onReset = noop } = this.props;
        if (queryDataSet) {
            const { current } = queryDataSet;
            if (current) {
                current.reset();
                onReset();
            }
            this.handleQuery(true);
        }
    }
    async handleQuery(collapse) {
        const { dataSet, queryDataSet, onQuery = noop } = this.props;
        if (queryDataSet && await queryDataSet.validate()) {
            dataSet.query();
            if (!collapse) {
                onQuery();
            }
        }
    }
    componentWillUnmount() {
        if (this.modal) {
            this.modal.close(true);
        }
    }
    getQueryBar() {
        const { queryFieldsLimit, queryFields, queryDataSet } = this.props;
        const { prefixCls } = this;
        if (queryDataSet && queryFields.length) {
            const currentFields = this.createFields(queryFields.slice(0, queryFieldsLimit), queryDataSet, false);
            const moreFields = this.createFields(queryFields.slice(queryFieldsLimit), queryDataSet, true);
            let more;
            let dirtyInfo;
            if (moreFields.length) {
                more = this.getMoreButton(moreFields);
                dirtyInfo = this.getDirtyInfo(queryDataSet, moreFields);
            }
            return (React.createElement("span", { className: `${prefixCls}-query-bar` },
                dirtyInfo,
                currentFields,
                React.createElement(Button, { color: ButtonColor.primary, onClick: () => { this.handleQuery(); } }, $l('Table', 'query_button')),
                more));
        }
    }
    getDirtyInfo(dataSet, moreFields) {
        if (dataSet &&
            moreFields.some(element => {
                const { name } = element.props;
                const field = dataSet.getField(name);
                return field ? field.isDirty(dataSet.current) : false;
            })) {
            const { prefixCls } = this;
            return (React.createElement("span", { className: `${prefixCls}-query-bar-dirty-info` },
                React.createElement(Icon, { type: "info" }),
                React.createElement("span", null, $l('Table', 'dirty_info')),
                React.createElement("a", { onClick: this.handleQueryReset }, $l('Table', 'restore'))));
        }
    }
    getMoreButton(moreFields) {
        return (React.createElement(Button, { color: ButtonColor.primary, funcType: FuncType.flat, onClick: () => this.openMore(moreFields) }, $l('Table', 'advanced_search')));
    }
    createFields(elements, dataSet, isMore) {
        return elements.map((element, index) => {
            const { name } = element.props;
            const props = {
                autoFocus: isMore && index === 0,
                onEnterDown: this.handleFieldEnter,
                style: isMore ? undefined : { width: pxToRem(130) },
            };
            const field = dataSet.getField(name);
            if (field) {
                const label = field.get('label');
                if (label) {
                    if (isMore) {
                        props.label = label;
                    }
                    else {
                        props.placeholder = label;
                    }
                }
            }
            return cloneElement(element, props);
        });
    }
    openMore(children) {
        this.modal = Modal.open({
            title: $l('Table', 'advanced_search'),
            children: React.createElement(Form, null, children),
            okText: $l('Table', 'query_button'),
            onOk: this.handleQuery,
            style: {
                width: pxToRem(400),
            },
            drawer: true,
        });
    }
    render() {
        const { pagination, buttons } = this.props;
        const { prefixCls } = this;
        return [
            React.createElement(TableButtons, { key: "toolbar", prefixCls: prefixCls, buttons: buttons }, this.getQueryBar()),
            pagination,
        ];
    }
};
TableToolBar.displayName = 'TableToolBar';
TableToolBar.defaultProps = {
    queryFieldsLimit: 1,
    pagination: null,
};
__decorate([
    autobind
], TableToolBar.prototype, "handleFieldEnter", null);
__decorate([
    autobind
], TableToolBar.prototype, "handleQueryReset", null);
__decorate([
    autobind
], TableToolBar.prototype, "handleQuery", null);
TableToolBar = __decorate([
    observer
], TableToolBar);
export default TableToolBar;
